<button mat-raised-button (click)="stergePDFBtnClick()"  >
  <mat-icon aria-hidden="false" aria-label="Sterge Document"> delete</mat-icon>

</button>
